import TaskScheduler from './scheduler'
import type { ITaskSchedulerConfig } from './scheduler'

export {
  EVENT_NAMES,
  EVENT_NAME_PREFIX,
  TASK_ERROR_CODE,
  TASK_STATE_CODE,
  getEvtNameFromType,
} from './helper'
export type {
  IErrorEventData,
  ITriggerEventData,
} from './helper'

const scheduler: { [deviceId: string]: TaskScheduler } = {}
export function createTaskScheduler (config: ITaskSchedulerConfig) {
  const deviceId = config ? config.deviceId : ''
  if (!deviceId) throw new Error('设备ID不能为空')
  if (scheduler[deviceId]) {
    return scheduler[deviceId]
  } else {
    const _config = config ? { ...config, deviceId } : { deviceId }
    const taskScheduler = new TaskScheduler(_config)
    scheduler[deviceId] = taskScheduler
    return taskScheduler
  }
}

export function getTaskScheduler (deviceId: string): TaskScheduler | null {
  const $scheduler = scheduler[deviceId]
  if (!$scheduler) return null
  return $scheduler
}

export default TaskScheduler
